import styles from './BlogSidebarLoader.module.scss';

export const BlogSidebarLoader = () => {
  return (
    <div className={styles['sidebar-loader']}>
      <div className={styles['sidebar-loader-author']}></div>

      <div className={styles['sidebar-loader-title']} />

      <div className={styles['sidebar-loader-parts']}>
        <div className={styles['sidebar-loader-part']} />
        <div className={styles['sidebar-loader-part']} />
        <div className={styles['sidebar-loader-part']} />
      </div>
    </div>
  );
};
